import styled from 'styled-components';
import { Typ51, Typ30, Typ35 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 56px;
  max-width: 538px;
  overflow: auto;
  flex-grow: 1;
`;

export const Title = styled(Typ51)`
  margin-bottom: 32px;
`;

export const SmallText = styled(Typ30)`
  margin-bottom: 32px;
`;

export const ExtraTextWrapper = styled.div`
  margin: 8px 0 46px;
  width: 100%;
  border: 1px solid #cfd8dc;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 24px 24px;
`;

export const ExtraText = styled(Typ35)``;

export const Button = styled(Btn021)`
  width: fit-content;
  align-self: flex-end;
  min-height: 36px;
`;
